import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { ChatbotWidget } from "./components/ChatbotWidget";
import { Home } from "./pages/Home";
import { QuotesList } from "./pages/QuotesList";
import Shop from "./pages/Shop";
import ProductPage from "./pages/ProductPage";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import Admin from "./pages/Admin";
import { Toaster } from "./components/ui/sonner";
import { LanguageProvider } from "./contexts/LanguageContext";
import { CartProvider } from "./contexts/CartContext";
import { ShopConfigProvider, useShopConfig } from "./contexts/ShopConfigContext";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  React.useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) { setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 50); return; }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

// Purchasing routes are only reachable when the shop is live
const LiveOnly = ({ children }) => {
  const { live, loading } = useShopConfig();
  if (loading) return null;
  return live ? children : <Navigate to="/shop" replace />;
};

function App() {
  return (
    <LanguageProvider>
      <ShopConfigProvider>
        <CartProvider>
          <div className="App">
            <BrowserRouter>
              <ScrollManager />
              <Header />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/shop/:slug" element={<LiveOnly><ProductPage /></LiveOnly>} />
                <Route path="/cart" element={<LiveOnly><CartPage /></LiveOnly>} />
                <Route path="/checkout" element={<LiveOnly><CheckoutPage /></LiveOnly>} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/quotes" element={<QuotesList />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
              <Footer />
              <WhatsAppButton />
              <ChatbotWidget />
              <Toaster />
            </BrowserRouter>
          </div>
        </CartProvider>
      </ShopConfigProvider>
    </LanguageProvider>
  );
}

export default App;
